import { ThemeFontSizeDefinition } from '../../font.model';

export type M3Role =
  | 'display-large'
  | 'display-medium'
  | 'display-small'
  | 'headline-large'
  | 'headline-medium'
  | 'headline-small'
  | 'title-large'
  | 'title-medium'
  | 'title-small'
  | 'body-large'
  | 'body-medium'
  | 'body-small'
  | 'label-large'
  | 'label-medium'
  | 'label-small';

const m3Size = (role: M3Role): string => `var(--mat-sys-${role}-size)`;
const m3LineHeight = (role: M3Role): string => `var(--mat-sys-${role}-line-height)`;
const m3Tracking = (role: M3Role): string => `var(--mat-sys-${role}-tracking)`;
const m3Weight = (role: M3Role): string => `var(--mat-sys-${role}-weight)`;

const typeScale = (role: M3Role): ThemeFontSizeDefinition => {
  return [
    m3Size(role),
    {
      lineHeight: m3LineHeight(role),
      letterSpacing: m3Tracking(role),
      fontWeight: m3Weight(role),
    },
  ];
};

const M3_ROLES: readonly M3Role[] = [
  'display-large',
  'display-medium',
  'display-small',
  'headline-large',
  'headline-medium',
  'headline-small',
  'title-large',
  'title-medium',
  'title-small',
  'body-large',
  'body-medium',
  'body-small',
  'label-large',
  'label-medium',
  'label-small',
] as const;

const buildTypeScaleRecord = (): Record<M3Role, ThemeFontSizeDefinition> => {
  const result: Partial<Record<M3Role, ThemeFontSizeDefinition>> = {};

  for (const role of M3_ROLES) {
    result[role] = typeScale(role);
  }

  return result as Record<M3Role, ThemeFontSizeDefinition>;
};

export const M3TypeScale: Record<M3Role, ThemeFontSizeDefinition> = buildTypeScaleRecord();
